module.exports = __webpack_public_path__ + "img/atlas_5000ml.e3e8cb30.png";